var rsz;
var initialized = false;
var stepCount = 0;

function doResize() {
  if (initialized == false) {
    $(".edm").each(function () {
      stepCount++;
      $(this).attr("data-step", stepCount);
      if (stepCount == 1) {
        $(this).addClass("active");
      }
    });
    initialized = true;
  }

  var qHeight = 0;
  var qWidth = 0;
  var qImageHeight = 0;

  $(".edm .edmQuestion").each(function () {
    $(this).find("edmQText").css("height", "auto");
    $(this).css("height", "auto");
  });
  //alert('ok');

  //$('.edm .edmQText').each(function(){
  $(".edm .edmQuestion").each(function () {
    var qH = $(this).height();
    var qIH = $(this).find(".edmQImage").height();
    if (qIH > qImageHeight) {
      qImageHeight = qIH;
    }

    if (qH > qHeight) {
      qHeight = qH;
    }
    var qW = $(this).width();
    if (qWidth < qW) {
      qWidth = qW;
    }

    //console.log('.edmTextNo height %s',$(this).parent().find('.edmTextNo').height());
  });

  // final question must be square (to allow for circular border)
  let qCircle = qHeight;
  if (qWidth < qCircle) {
    qCircle = qWidth;
  }

  $(".edm.questionstep .edmQuestion").css("height", qHeight + 24 + "px");
  //$('.edm.questionstep .edmQuestion .edmQText').css('height',(qHeight+24 - qImageHeight)+'px');

  console.log(
    "question = %s, image height=%s, text = %s",
    qHeight + 24,
    qImageHeight,
    qHeight + 24 - qImageHeight
  );

  //$('.edm.final .edmQuestion').css('height',(qCircle+24)+'px');
  //$('.edm.final .edmQuestion').css('width',(qCircle+24)+'px');
  $(".edm.final .edmQuestion").css("border-radius", qCircle + 24 + "px");

  var tHeight = 0;
  $(".edm.questionstep .edmTWrap").each(function () {
    var tH = $(this).height();
    if (tH > tHeight) {
      tHeight = tH;
    }
  });
  $(".edm.questionstep .edmT").css("height", tHeight + 24 + "px");
}

function edmButtonClick($button) {
  var btn = $button.attr("data-button");
  var $item = $button.parent().parent();
  var stepItem = $item.attr("data-step");
  switch (btn) {
    case "edmNo": //$item.find('.edmTextUnsure').css('display','none');
      //$item.find('.edmTextNo').css('visibility','visible');
      //$item.find('.edmTextNo').css('display','block');
      $item.removeClass("StatusYes");
      $item.removeClass("StatusUnsure");
      $item.addClass("StatusNo");
      for (var i = 1 * stepItem + 1; i <= stepCount; i++) {
        $('.edm[data-step="' + i + '"]').removeClass("active");
      }
      break;
    case "edmUnsure":
      //$item.find('.edmTextNo').css('visibility','hidden');
      //$item.find('.edmTextNo').css('display','none');
      //$item.find('.edmTextUnsure').css('display','block');
      $item.removeClass("StatusYes");
      $item.removeClass("StatusNo");
      $item.addClass("StatusUnsure");
      for (var i = 1 * stepItem + 1; i <= stepCount; i++) {
        $('.edm[data-step="' + i + '"]').removeClass("active");
      }

      break;
    case "edmYes":
      //$item.find('.edmTextUnsure').css('display','none');
      //$item.find('.edmTextNo').css('visibility','hidden');
      $item.removeClass("StatusNo");
      $item.removeClass("StatusUnsure");
      $item.addClass("StatusYes");
      if (stepItem < stepCount) {
        var nextStep = 1 * stepItem + 1;
        $('.edm[data-step="' + nextStep + '"]').addClass("active");
        $('.edm[data-step="' + nextStep + '"]')[0].scrollIntoView({
          behavior: "smooth",
        });
      }

      break;
  }
  doResize();
}

export default function edmSetup() {
  if ($(".edmB").length !== 0) {
    $(".edmB").each(function () {
      $(this).click(function () {
        edmButtonClick($(this));
      });
    });

    $(window).resize(function () {
      clearTimeout(rsz);
      rsz = setTimeout(function () {
        doResize(false);
      }, 250);
    });
    doResize(true);
  }
}

// $(document).ready(function () {
//   edmSetup();
// });
